import {
  Component,
  Input,
  NgZone,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Users } from 'server/shared/collections/users';
import { Employment } from 'server/shared/models/employment';
import { InpoolLanguage } from 'server/shared/models/InpoolLanguage';
import { User } from 'server/shared/models/user';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-employment-canceled-info',
  templateUrl: './employment-canceled-info.component.html',
  styleUrls: ['./employment-canceled-info.component.scss'],
})
export class EmploymentCanceledInfoComponent implements OnChanges {
  lang: InpoolLanguage = 'de';
  @Input() employment?: Employment;

  cancelUser?: User;

  constructor(
    private ngZone: NgZone,
    private translationService: TranslationService,
  ) {
    Tracker.autorun(() => {
      this.ngZone.run(() => {
        this.lang = this.translationService.getLanguage();
      });
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.employment) {
      this.cancelUser = Users.findOne({
        _id: this.employment?.canceledBy,
      });
    }
  }
}
